import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./index.scss";
import { useLocation, useHistory, Redirect } from "react-router-dom";

import InventoryTab from "./components/InventoryTab/InventoryTabs";
import POSupplierDevice from "./components/POSupplierDevice";
import Stock from "./components/Stock";
import ChargingPlan from "./components/ChargingPlan";
import RollOut from "./components/RollOut";
import Distribution from "./components/Distribution";
import WarehouseManagement from "./components/WarehouseManagement";

const InventoryManagement = () => {
  const location = useLocation();
  const history = useHistory();

  const tabs = useMemo(
    () => [
      {
        id: "po-supplier",
        label: "PO/Supplier/Device",
        component: POSupplierDevice,
        allowedUserTypes: ["bkash-super-user"],
      },
      {
        id: "warehouse",
        label: "Warehouse",
        component: WarehouseManagement,
        allowedUserTypes: ["bkash-super-user", "warehouse_manager"],
      },
      {
        id: "stock",
        label: "Stock",
        component: Stock,
        allowedUserTypes: ["bkash-super-user"],
      },
      {
        id: "charging-plan",
        label: "Charging Plan",
        component: ChargingPlan,
        allowedUserTypes: ["bkash-super-user", "agency_user"],
      },
      {
        id: "roll-out",
        label: "Roll Out",
        component: RollOut,
        allowedUserTypes: ["bkash-super-user", "agency_user"],
      },
      {
        id: "distribution",
        label: "Distribution",
        component: Distribution,
        allowedUserTypes: [
          "bkash-super-user",
          "cluster_head",
          "regional_manager",
          "area_manager",
          "territory_manager",
          "agency_user",
        ],
      },
    ],
    []
  );

  const getComponentById = useCallback((tabsArray, id) => {
    const tab = tabsArray.find((tab) => tab.id === id);
    return tab ? React.createElement(tab.component) : null;
  }, []);

  const userType = useMemo(
    () => JSON.parse(localStorage.getItem("currUserType")),
    []
  );

  const filteredTabs = useMemo(() => {
    return tabs
      .filter((tab) => tab.allowedUserTypes.includes(userType))
      .sort((a, b) => {
        if (userType === "agency_user") {
          if (a.id === "distribution") return -1;
          if (b.id === "distribution") return 1;
        }
        return 0;
      });
  }, [tabs, userType]);

  const [activeTab, setActiveTab] = useState(() => {
    const params = new URLSearchParams(location.search);
    const tabFromUrl = params.get("tab");
    const defaultTab = filteredTabs[0]?.id;

    if (tabFromUrl && filteredTabs.find((tab) => tab.id === tabFromUrl)) {
      return tabFromUrl;
    }
    return defaultTab;
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const currentTab = params.get("tab");
    const validTab = filteredTabs.find((tab) => tab.id === currentTab);
    const defaultTab = filteredTabs[0]?.id;

    if (!currentTab || !validTab) {
      if (defaultTab) {
        params.set("tab", defaultTab);
        params.delete("subtab");
        params.delete("detailTab");
        params.delete("dhDetailTab");
        params.delete("view");
        params.delete("dhId");
        history.replace(`${location.pathname}?${params.toString()}`);
        setActiveTab(defaultTab);
      }
    } else if (currentTab !== activeTab && validTab) {
      setActiveTab(currentTab);
    }
  }, [location.search, filteredTabs, history, location.pathname]); // eslint-disable-line

  const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
  if (!localUserToken) return <Redirect to="/signin" />;

  const handleTabChange = (tabId) => {
    const params = new URLSearchParams(location.search);
    params.set("tab", tabId);
    params.delete("subtab");
    params.delete("detailTab");
    params.delete("dhDetailTab");
    params.delete("view");
    params.delete("dhId");
    history.push(`${location.pathname}?${params.toString()}`);
    setActiveTab(tabId);
  };

  return (
    <div className="main-container inventory-management">
      <div className="inventory-header">
        <h1 className="page-title">Device Management</h1>
      </div>
      <div className="inventory-content">
        <InventoryTab
          tabs={filteredTabs}
          activeTab={activeTab}
          setActiveTab={handleTabChange}
        />
        {getComponentById(filteredTabs, activeTab)}
      </div>
    </div>
  );
};

export default InventoryManagement;
